module.exports = __webpack_public_path__ + "static/media/Clients.63f8b305.png";